import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import CardText from 'react/shared/components/true_link/lab/form/wizard/CardText';
import PALETTE from 'react/shared/theme/palette';
import currentModuleShape from 'react/signups/card/shapes/CurrentModule';
import userTypeShape from 'react/signups/card/shapes/UserType';
import { getCurrentModuleDisplayName } from 'react/signups/card/utils';

const useStyles = makeStyles({
  displayName: {
    color: PALETTE.emerald,
    fontWeight: '600',
    textTransform: 'uppercase',
  },
});

export default function ModuleDisplayName({ cardholderFirstName, currentModule, userType }) {
  const classes = useStyles();
  const displayName = useMemo(
    () => getCurrentModuleDisplayName(currentModule, userType, cardholderFirstName),
    [cardholderFirstName, currentModule, userType],
  );

  if (!displayName) {
    return null;
  }

  return (
    <CardText className={classes.displayName} variant="body2">
      {displayName}
    </CardText>
  );
}

ModuleDisplayName.propTypes = {
  cardholderFirstName: PropTypes.string,
  currentModule: currentModuleShape.isRequired,
  userType: userTypeShape,
};
